module.exports = __webpack_public_path__ + "static/img/downApp.d3a7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addCar/downApp.png
// module id = +pzd
// module chunks = 1